import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiService } from '../../services/api.service';
import { Router } from '@angular/router';
import { switchMap, map, catchError, throwError } from 'rxjs';
import { IParcelData } from '../../interfaces/response-verify-delivery';
import {
  RETRIEVE_CONFIRM_CLIENT_ACCEPTANCE_DATAMATRIX,
  RETRIEVE_CONFIRM_CLIENT_ACCEPTANCE_DATAMATRIX_SUCCESS,
  RETRIEVE_CONFIRM_CODICE_BUSTA,
  RETRIEVE_CONFIRM_CODICE_BUSTA_SUCCESS,
  RETRIEVE_ETICHETTE_LOTTOMATICA,
  RETRIEVE_ETICHETTE_LOTTOMATICA_SUCCESS,
  RETRIEVE_ETICHETTE_WEBAPP,
  RETRIEVE_ETICHETTE_WEBAPP_SUCCESS,
  RETRIEVE_CONFIRM_CLIENT_ACCEPTANCE,
  RETRIEVE_CONFIRM_CLIENT_ACCEPTANCE_SUCCESS,
  RETRIEVE_CONSEGNA_PACCO,
  RETRIEVE_CONSEGNA_PACCO_SUCCESS,
  RETRIEVE_PACCO_SMARRITO,
  RETRIEVE_PACCO_SMARRITO_SUCCESS,
  RETRIEVE_PARCEL_SALE,
  RETRIEVE_PARCEL_SALE_SUCCESS,
  RETRIEVE_RIFIUTA_PACCO,
  RETRIEVE_RIFIUTA_PACCO_SUCCESS,
  RETRIEVE_VERIFY_DELIVERY,
  RETRIEVE_VERIFY_DELIVERY_NO_PIN,
  RETRIEVE_VERIFY_DELIVERY_NO_PIN_SUCCESS,
  RETRIEVE_VERIFY_DELIVERY_SUCCESS,
  RETRIEVE_VERIFY_SALE,
  RETRIEVE_VERIFY_SALE_SUCCESS,
  VERIFICA_ACCETTAZIONE_STAMPA_PAPERLESS,
  VERIFICA_ACCETTAZIONE_STAMPA_PAPERLESS_SUCCESS,
} from './client-activities.actions';
import { IResponseRifiutaPacco } from '../../interfaces/rifiuta-pacco';
import { ResponseAccettazioneDatamatrix, ResponseConfirmClientAcceptance, ResponseConfirmCodiceBusta, ResponseEtichettaLottomatica, ResponseEtichettaWebApp } from '../../interfaces/response-confirm-client-acceptance';
import { ISaleData } from '../../interfaces/response-verify-sale';
import { IParcelSale } from '../../interfaces/response-parcel-sale';
import { HttpErrorResponse } from '@angular/common/http';
import { ADD_MESSAGE } from '../messages/messages.actions';
import { Store } from '@ngrx/store';
import { IResponseVerificaAccettazioneStampaPaperless } from '../../interfaces/verifica-accettazione-stampa-paperless';
@Injectable()
export class ClientActivitiesEffects {
  retrieveVerifyDelivery$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RETRIEVE_VERIFY_DELIVERY),
      switchMap(({ pin }) => this.api.retrieveVerifyDelivery(pin)),
      map((responseVerifyDelivery: IParcelData) => {
        return RETRIEVE_VERIFY_DELIVERY_SUCCESS({ responseVerifyDelivery });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveVerifyDeliveryNoPin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RETRIEVE_VERIFY_DELIVERY_NO_PIN),
      switchMap(({ parcelCode }) =>
        this.api.retrieveVerifyDeliveryNoPin(parcelCode)
      ),
      map((responseVerifyDeliveryNoPin: IParcelData) => {
        return RETRIEVE_VERIFY_DELIVERY_NO_PIN_SUCCESS({
          responseVerifyDeliveryNoPin,
        });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveRifiutaPacco$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RETRIEVE_RIFIUTA_PACCO),
      switchMap(({ payload }) => this.api.retrieveRifiutaPacco(payload)),
      map((responseRifiutaPacco: IResponseRifiutaPacco) => {
        return RETRIEVE_RIFIUTA_PACCO_SUCCESS({ responseRifiutaPacco });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveConsegnaPacco$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RETRIEVE_CONSEGNA_PACCO),
      switchMap(({ payload }) => this.api.retrieveConsegnaPacco(payload)),
      map((responseConsegnaPacco: IResponseRifiutaPacco) => {
        return RETRIEVE_CONSEGNA_PACCO_SUCCESS({ responseConsegnaPacco });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  verificaAccettazioneStampaPaperless$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VERIFICA_ACCETTAZIONE_STAMPA_PAPERLESS),
      switchMap(({ payload }) => this.api.verificaAccettazioneStampaPaperless(payload)),
      map((responseVerificaAccettazioneStampaPaperless: IResponseVerificaAccettazioneStampaPaperless) => {
        return VERIFICA_ACCETTAZIONE_STAMPA_PAPERLESS_SUCCESS({ responseVerificaAccettazioneStampaPaperless });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrievePaccoSmarrito$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RETRIEVE_PACCO_SMARRITO),
      switchMap(({ payload }) => this.api.retrievePaccoSmarrito(payload)),
      map((responsePaccoSmarrito: IResponseRifiutaPacco) => {
        return RETRIEVE_PACCO_SMARRITO_SUCCESS({ responsePaccoSmarrito });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );
  retrieveVerifySale$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RETRIEVE_VERIFY_SALE),
      switchMap(({ code }) => this.api.retrieveVerifySale(code)),
      map((responseVerifySale: ISaleData) => {
        return RETRIEVE_VERIFY_SALE_SUCCESS({ responseVerifySale });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveParcelSale$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RETRIEVE_PARCEL_SALE),
      switchMap(({ payload }) => this.api.retrieveParcelSale(payload)),
      map((responseParcelSale: IParcelSale) => {
        return RETRIEVE_PARCEL_SALE_SUCCESS({ responseParcelSale });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );
  retrieveConfirmClientAcceptance$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RETRIEVE_CONFIRM_CLIENT_ACCEPTANCE),
      switchMap(({ boxCode }) =>
        this.api.retrieveConfirmClientAcceptance(boxCode)
      ),
      map(
        (responseConfirmClientAcceptance: ResponseConfirmClientAcceptance) => {
          return RETRIEVE_CONFIRM_CLIENT_ACCEPTANCE_SUCCESS({
            responseConfirmClientAcceptance,
          });
        }
      ),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveConfirmClientAcceptanceDatamatrix$ = createEffect(() =>
  this.actions$.pipe(
    ofType(RETRIEVE_CONFIRM_CLIENT_ACCEPTANCE_DATAMATRIX),
    switchMap(({dataMatrix}) => this.api.retrieveConfirmClientAcceptanceDatamatrix(dataMatrix)),
    map((responseConfirmClientAcceptanceDatamatrix: ResponseAccettazioneDatamatrix) => {
      return RETRIEVE_CONFIRM_CLIENT_ACCEPTANCE_DATAMATRIX_SUCCESS({ responseConfirmClientAcceptanceDatamatrix });
    }),
    catchError((error: HttpErrorResponse) => {
      this.addErrorMessage(error.message)
      return throwError({ error });
    })
  )
);

retrieveEtichetteBXLwebapp$ = createEffect(() =>
  this.actions$.pipe(
    ofType(RETRIEVE_ETICHETTE_WEBAPP),
    switchMap(() => this.api.retriveEtichettaBXLwebApp()),
    map((responseEtichettaWebApp: ResponseEtichettaWebApp) => {
      return RETRIEVE_ETICHETTE_WEBAPP_SUCCESS({ responseEtichettaWebApp });
    }),
    catchError((error: HttpErrorResponse) => {
      this.addErrorMessage(error.message)
      return throwError({ error });
    })
  )
);

retrieveEtichetteBXLlottomatica$ = createEffect(() =>
  this.actions$.pipe(
    ofType(RETRIEVE_ETICHETTE_LOTTOMATICA),
    switchMap(() => this.api.retriveEtichettaBXLwebApp()),
    map((responseEtichettaLottomatica: ResponseEtichettaLottomatica) => {
      return RETRIEVE_ETICHETTE_LOTTOMATICA_SUCCESS({ responseEtichettaLottomatica });
    }),
    catchError((error: HttpErrorResponse) => {
      this.addErrorMessage(error.message)
      return throwError({ error });
    })
  )
);

retrieveConfirmCodiceBustaBXL$ = createEffect(() =>
  this.actions$.pipe(
    ofType(RETRIEVE_CONFIRM_CODICE_BUSTA),
    switchMap(({codiceBusta}) => this.api.verificaCodiceBustaBXL(codiceBusta)),
    map((responseConfirmCodiceBusta: ResponseConfirmCodiceBusta) => {
      return RETRIEVE_CONFIRM_CODICE_BUSTA_SUCCESS({ responseConfirmCodiceBusta });
    }),
    catchError((error: HttpErrorResponse) => {
      this.addErrorMessage(error.message)
      return throwError({ error });
    })
  )
);

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private router: Router,
    private store: Store
  ) {}

  private addErrorMessage(message: string): void {
    this.store.dispatch(ADD_MESSAGE({ message: message }));
  }
}
